function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import _setTimeout from "@babel/runtime-corejs3/core-js/set-timeout";
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { FullscreenModal } from "@xo-union/tk-component-modals";
import BrandLogo from "@xo-union/component-brand-logo";
import { Link, Button } from "@xo-union/tk-component-buttons";
import styles from "./styles.css";
export default function ModalQuiz(_ref) {
  var isOpen = _ref.isOpen,
    title = _ref.title,
    subtitle = _ref.subtitle,
    openQuizText = _ref.openQuizText,
    closeQuizText = _ref.closeQuizText,
    closeModal = _ref.closeModal,
    quizUrl = _ref.quizUrl;
  var _useState = useState(isOpen),
    _useState2 = _slicedToArray(_useState, 2),
    shouldRender = _useState2[0],
    setShouldRender = _useState2[1];
  useEffect(function () {
    if (isOpen) {
      var _document$activeEleme;
      setShouldRender(true);
      (_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 || _document$activeEleme.blur();
    } else {
      var timeout = _setTimeout(function () {
        return setShouldRender(false);
      }, 300);
      return function () {
        return clearTimeout(timeout);
      };
    }
  }, [isOpen]);
  if (!shouldRender) {
    return null;
  }
  return /*#__PURE__*/React.createElement(FullscreenModal, {
    className: "".concat(styles['header-hidden'], " ").concat(isOpen ? styles["show"] : styles["hide"]),
    onClose: function onClose() {}
  }, /*#__PURE__*/React.createElement("section", {
    className: styles['modal-quiz-bg']
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles['modal-quiz-desses-bg'])
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles['modal-quiz-content'])
  }, /*#__PURE__*/React.createElement(BrandLogo, {
    name: "theknot",
    color: "primary",
    size: "lg",
    className: styles['modal-quiz-content--logo']
  }), /*#__PURE__*/React.createElement("div", {
    className: styles['modal-quiz-texts']
  }, /*#__PURE__*/React.createElement("h3", {
    className: styles['modal-quiz-content--title']
  }, title), /*#__PURE__*/React.createElement("p", {
    className: styles['modal-quiz-content--subtitle']
  }, subtitle)), /*#__PURE__*/React.createElement("div", {
    className: styles['modal-quiz-links']
  }, /*#__PURE__*/React.createElement(Link, {
    color: "primary",
    size: "md",
    href: quizUrl,
    className: styles['modal-quiz-link']
  }, openQuizText), /*#__PURE__*/React.createElement(Button, {
    color: "tertiary",
    size: "md",
    onClick: closeModal
  }, closeQuizText))))));
}
ModalQuiz.defaultProps = {
  title: 'Find dresses in your style',
  subtitle: 'Get matched with designers and wedding dresses that fit your look.',
  openQuizText: 'Take the quiz',
  closeQuizText: 'Not now'
};
process.env.NODE_ENV !== "production" ? ModalQuiz.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  openQuizText: PropTypes.string.isRequired,
  closeQuizText: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
  quizUrl: PropTypes.string.isRequired
} : void 0;